/*
 * Copyright (c) Nexign, JSC, 2023.
 */
/**
 *
 * @author Evgeniy Naumov
 * @version 1.26.0
 * @since 1.25.1
 */

import { FC, ReactElement, useCallback } from 'react';

import { IconButton } from '@nexign/scc-ui-kit';
import isFunction from 'lodash/isFunction';

import { icons } from '@/main/assets';

import { ImgStyled } from '../Block/Img';
import EllipseText from '../EllipsisText/EllipsisText';
import { AttachedItemContainerStyled } from './AttachedItemStyled';

interface IAttachedFileProps {
    title: string | ReactElement;
    onDelete: (id?: number) => void;
    id?: number;
    fullWidth?: boolean;
}

const AttahcedItem: FC<IAttachedFileProps> = ({ id, title, onDelete, fullWidth = true }) => {
    const currentTitle =
        typeof title === 'string' ? (
            <EllipseText maxHeight="300px" overflow="auto" tooltipMsg={title}>
                {title}
            </EllipseText>
        ) : (
            title
        );

    const handleDelete = useCallback(() => {
        if (isFunction(onDelete)) {
            onDelete(id);
        }
    }, [id, onDelete]);
    return (
        <AttachedItemContainerStyled $fullWidth={fullWidth}>
            {currentTitle}
            <IconButton onClick={handleDelete}>
                <ImgStyled className="small icon__close" src={icons.cancelMiddleIcon} />
            </IconButton>
        </AttachedItemContainerStyled>
    );
};

export default AttahcedItem;
